export const CapitalizeFirstLetterOnly = (value: string) : string => {
  if(!value || value.length === 0)
  {
    return value;
  }

  return value[0].toUpperCase() + value.toLowerCase().slice(1);
}

export const FormatName = (firstName : string, lastName: string, middleInitial: string | undefined) : string =>
{
  if(middleInitial && middleInitial.trim().length > 0)
  {
    return `${firstName?.toUpperCase()} ${middleInitial?.toUpperCase()} ${lastName?.toUpperCase()}`.toUpperCase();    
  }
  return `${firstName?.toUpperCase()} ${lastName?.toUpperCase()}`;
}

